export enum AgentValidationType {
  None = "None",
  Barcode = "Barcode",
  ProNumber = "ProNumber",
  Click = "Click"
}
